import { StoreState } from '@/core/models/store.interface';
import { Channel } from 'laravel-echo';
import { Module } from 'vuex';

export interface WebSocketState {
   userChannel?: Channel;
   tenantChannel?: Channel;
}

const WebSocketStore: Module<WebSocketState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_USER_CHANNEL(state, channel?: Channel) {
         state.userChannel = channel;
      },
      SET_TENANT_CHANNEL(state, channel?: Channel) {
         state.tenantChannel = channel;
      },
   },
   actions: {},
};

export default WebSocketStore;
